export class SpreadingConfigModel {
    title: string = '';
    spreadingType: number | null = null;
    selectedMeasure: number | null = null;
    startDate: Date = new Date();
    endDate: Date = new Date();
    spreadingPreference: number | null = null;
    
    fromLocationGrain: number | null = null;
    toLocationGrain: number | null = null;
    fromTimeGrain: number | null = null;
    toTimeGrain: number | null = null;
    }




